<template>
  <div>
    <span>{{ payment.formatted_date_time }}</span>
    <button v-if="canEdit && !editing" type="button" class="ml-2 text-primary" aria-label="Edit payment date" @click="open">Edit date</button>
    <div v-if="editing && canEdit" class="mt-2">
      <label>Date Time (US Eastern)
        <input v-model="dateValue" type="datetime-local" step="1" :disabled="saving" class="border p-2" />
      </label>
      <button type="button" :disabled="saving" :aria-busy="saving" class="ml-2 text-primary" @click="save">{{ saving ? 'Saving…' : 'Save date' }}</button>
      <button type="button" :disabled="saving" class="ml-2" @click="editing = false">Cancel</button>
      <p v-if="error" role="alert" class="text-red-600">{{ error }}</p>
    </div>
    <p v-if="saved" role="status">Payment date updated.</p>
  </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment-timezone';
import { canEditAffiliatePaymentDate } from './payment-controls';
export default {
  props: { payment: { type: Object, required: true } },
  data: () => ({ editing: false, saving: false, dateValue: '', error: '', saved: false }),
  computed: {
    canEdit() { return canEditAffiliatePaymentDate(this.$store.state.user); }
  },
  methods: {
    open() {
      if (!this.canEdit) return;
      this.dateValue = moment.unix(this.payment.created_at).tz('America/New_York').format('YYYY-MM-DDTHH:mm:ss');
      this.error = ''; this.saved = false; this.editing = true;
    },
    async save() {
      if (!this.canEdit || this.saving) return;
      const date = moment.tz(this.dateValue, ['YYYY-MM-DDTHH:mm:ss', 'YYYY-MM-DDTHH:mm'], true, 'America/New_York');
      if (!date.isValid() || !date.format('YYYY-MM-DDTHH:mm:ss').startsWith(this.dateValue)) {
        this.error = 'Enter a valid US Eastern date and time.'; return;
      }
      this.saving = true; this.error = '';
      try {
        const resource = Number(this.payment.type) === 4 ? 'affiliate-payment-bonuses' : 'affiliate-payments';
        const result = await axios.patch(`/${resource}/${this.payment.id}/date`, { recorded_at: date.format('YYYY-MM-DDTHH:mm:ssZ') });
        if (!result.data.success) throw new Error('Payment date was not saved.');
        this.$emit('updated', { ...this.payment, created_at: result.data.created_at,
          formatted_date_time: date.format('DD MMM YYYY') + ' - ' + date.format('hh:mm a z') });
        this.editing = false; this.saved = true;
      } catch (error) {
        this.error = error.response?.data?.message || error.message || 'Could not save the payment date.';
      } finally { this.saving = false; }
    }
  }
};
</script>
